const NAMESPACE = 'WIDGET_DATA';

const SET_ORIGIN_INPUT = `${NAMESPACE}/SET_ORIGIN_INPUT`;
const SET_DESTINATION_INPUT = `${NAMESPACE}/SET_DESTINATION_INPUT`;
const SET_ORIGIN_PLACE_ID = `${NAMESPACE}/SET_ORIGIN_PLACE_ID`;
const SET_DESTINATION_PLACE_ID = `${NAMESPACE}/SET_DESTINATION_PLACE_ID`;

export {
    SET_DESTINATION_INPUT,
    SET_DESTINATION_PLACE_ID,
    SET_ORIGIN_INPUT,
    SET_ORIGIN_PLACE_ID,
};

export default NAMESPACE;
